/* START SOFTSKILLS USER COURSE */
export const ANSWER_SOFTSKILLS_SURVEY = "ANSWER_SOFTSKILLS_SURVEY"
export const ANSWER_SOFTSKILLS_SURVEY_SUCCESS =
  "ANSWER_SOFTSKILLS_SURVEY_SUCCESS"
export const ANSWER_SOFTSKILLS_SURVEY_CLEAN = "ANSWER_SOFTSKILLS_SURVEY_CLEAN"
export const ANSWER_SOFTSKILLS_SURVEY_ERROR = "ANSWER_SOFTSKILLS_SURVEY_ERROR"
